import { select } from 'redux-saga/effects';
import { readerTaskSlice } from '../readerTask/readerTask.slice';
import { readerSubTaskSlice } from '../readerSubTask/readerSubTask.slice';
import { tabCoordinationSlice } from './tabCoordination/tabCoordination.slice';
import { TabCoordinationState } from './tabCoordination/tabCoordination.types';
import { FormManagementState } from './formManagement/formManagement.types';
import { formManagementSlice } from './formManagement/formManagement.slice';

const { getTabCoordinationState } = tabCoordinationSlice.selectors;
const { selectFormManagementState: getFormManagementState } =
  formManagementSlice.selectors;
const { selectReaderTask, selectCurrentVisit, selectState } =
  readerTaskSlice.selectors;
const { selectCurrentReaderSubTask } = readerSubTaskSlice.selectors;

export function* selectTabCoordinationState() {
  const state: TabCoordinationState = yield select(getTabCoordinationState);
  return state;
}
export function* selectFormManagementState() {
  const state: FormManagementState = yield select(getFormManagementState);
  return state;
}

export function* selectReadingTaskState() {
  const state: ReturnType<typeof selectReaderTask> =
    yield select(selectReaderTask);

  return state;
}

export function* selectCurrentSubTaskState() {
  const state: ReturnType<typeof selectCurrentReaderSubTask> = yield select(
    selectCurrentReaderSubTask
  );

  return state;
}

export function* selectReaderTaskState() {
  const state: ReturnType<typeof selectState> = yield select(selectState);

  return state;
}

export function* selectCurrentVisitState() {
  const state: ReturnType<typeof selectCurrentVisit> =
    yield select(selectCurrentVisit);

  return state;
}

export function* selectScoringFormCode() {
  const subTask = yield* selectCurrentSubTaskState();
  if (subTask) {
    const v = subTask.visits?.find(v => v.visitId === subTask.visitId);
    if (v?.scoringCode) {
      return v.scoringCode;
    }
  }
  const visit = yield* selectCurrentVisitState();
  if (visit?.scoringCode) {
    return visit.scoringCode;
  }
  return '';
}

export function clearDataFromLocalStorage() {
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('scoringData-')) {
      localStorage.removeItem(key);
    }
  });
}
